"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const valueIsFunctionsEvaluatedListInstructions_1 = __importDefault(require("../../typeAssertions/valueIsFunctionsEvaluatedListInstructions"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const buildProgresiveUpdater_1 = __importDefault(require("../utils/buildProgresiveUpdater"));
const orderListItems_1 = __importDefault(require("../utils/orderListItems"));
const callableGenerateSwiperContent = async ({ entryVars: { data: listDataEntryVar, swiperGenerationInstruction, }, processor, lastFunctionsOutputs, extraFunctionDefinitions, executeProcesses, callbacks, store, }) => {
    let itemContexts = [];
    if (typeof listDataEntryVar !== 'object' || !listDataEntryVar) {
        react_native_1.Alert.alert('Invalid list of data', `${listDataEntryVar}`);
        return;
    }
    const listData = listDataEntryVar;
    if (!(0, valueIsFunctionsEvaluatedListInstructions_1.default)(swiperGenerationInstruction)) {
        react_native_1.Alert.alert('Invalid list instructions', `${swiperGenerationInstruction}`);
        return;
    }
    const { listControlId, listOptions = {}, } = swiperGenerationInstruction;
    if ((0, valueIsNullOrUndef_1.default)(listControlId)) {
        react_native_1.Alert.alert('Invalid list control id', `${swiperGenerationInstruction}`);
        return;
    }
    if (listOptions.orderByEnabled) {
        itemContexts = (0, orderListItems_1.default)(listData, (entry) => {
            const internalData = entry[1];
            if (!(0, valueIsRecord_1.default)(internalData)) {
                return undefined;
            }
            const index = (0, valueIsString_1.default)(listOptions.orderByField) ? listOptions.orderByField : '';
            return internalData[index];
        }).reduce((arrayAccum, [id, data]) => ([...arrayAccum, { id, data }]), []);
    }
    else {
        itemContexts = (0, orderListItems_1.default)(listData, (entry) => entry[0])
            .reduce((arrayAccum, [id, data]) => ([...arrayAccum, { id, data }]), []);
    }
    const listUpdater = await (0, buildProgresiveUpdater_1.default)({
        store,
        processor,
        itemContexts,
        lastFunctionsOutputs,
        listInstructions: Object.assign(Object.assign({}, swiperGenerationInstruction), { listControlId }),
        extraFunctionDefinitions,
        onDone: () => {
            executeProcesses(undefined, callbacks.onDone);
        },
        isSwiper: true,
    });
    processor.root.registerListUpdater(listControlId, listUpdater);
    if (listUpdater.makeIteration) {
        listUpdater.makeIteration();
    }
};
exports.default = callableGenerateSwiperContent;
